import React from 'react';
import { acceptableItems } from '../data/mock';
import { HardHat, Mountain, TreeDeciduous, Axe, XCircle } from 'lucide-react';

const iconMap = {
  HardHat: HardHat,
  Mountain: Mountain,
  TreeDeciduous: TreeDeciduous,
  Logs: Axe
};

const notAccepted = [
  "Hazardous chemicals", "Paints & solvents", "Batteries", "Propane tanks",
  "Tires", "Medical waste", "Flammables", "Motor oil"
];

const AcceptableItems = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-[#1a365d] to-[#0f2847]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-blue-300 font-semibold tracking-wider uppercase text-sm">What Goes In</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mt-4 mb-6">
            Materials We <span className="text-blue-300">Accept</span>
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Not sure if we can take it? Here's a quick guide. When in doubt, give us a call!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Accepted Items */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 flex items-center space-x-2">
              <span className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">✓</span>
              <span>We Accept</span>
            </h3>
            <div className="grid sm:grid-cols-2 gap-4">
              {acceptableItems.map((item, index) => {
                const IconComponent = iconMap[item.icon];
                return (
                  <div
                    key={index}
                    className="bg-white/10 backdrop-blur-sm rounded-xl p-5 hover:bg-white/15 transition-all duration-300 group"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-blue-500/30 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500/50 transition-colors">
                        <IconComponent className="h-6 w-6 text-white" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-white mb-1">{item.title}</h4>
                        <p className="text-white/60 text-sm leading-relaxed">{item.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Not Accepted Items */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6 flex items-center space-x-2">
              <span className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">✕</span>
              <span>We Cannot Accept</span>
            </h3>
            <div className="bg-white/5 rounded-xl p-6">
              <p className="text-white/70 mb-4">
                For safety and environmental reasons, the following items require special disposal:
              </p>
              <div className="grid grid-cols-2 gap-3">
                {notAccepted.map((item, index) => (
                  <div key={index} className="flex items-center space-x-2 text-white/80">
                    <XCircle className="h-4 w-4 text-red-400 flex-shrink-0" />
                    <span className="text-sm">{item}</span>
                  </div>
                ))}
              </div>
              <p className="text-white/50 text-sm mt-4 pt-4 border-t border-white/10">
                Need to dispose of hazardous materials? We can point you to the right resources.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcceptableItems;
